let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3UHw6")).then(() => parcelRequire('bZnkC'));